<div class="revoke-reservation-dialog">
  <div class="ws-popup-header">
    <div>
      {{ "revoke_dialog.title" | translate }}
    </div>
  </div>

  <div class="ws-popup-content">
    <div class="ws-popup-body">
      <p class="message" [innerHTML]="'revoke_dialog.main_message' | translate"></p>
      <div class="refund-section" *ngIf="showRefundSection">
        <div class="refund-checkbox-container">
          <mat-checkbox [(ngModel)]="shouldRefund" [disabled]="isProcessing">
            <span class="checkbox-label">{{
              "revoke_dialog.refund_payment" | translate
            }}</span>
          </mat-checkbox>
          <p class="refund-description">
            {{
              "revoke_dialog.refund_description"
                | translate: { amount: refundAmount }
            }}
          </p>
        </div>

        <div class="alert-banner" *ngIf="shouldRefund">
          <div class="alert-content">
            <span class="danger-icon">⚠️</span>
            <div class="alert-text">
              <div class="alert-description">
                {{ "revoke_dialog.irreversible_warning" | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="processing-overlay" *ngIf="isProcessing">
        <mat-spinner diameter="40"></mat-spinner>
        <p class="processing-text">{{ processingMessage | translate }}</p>
      </div>
    </div>

    <div class="ws-popup-footer center">
      <ws-button
        (click)="onCancel()"
        [disabled]="isProcessing"
        [callToActionType]="'tertiary'"
      >
        {{ "Cancel" | translate }}
      </ws-button>
      <ws-button
        color="warn"
        (click)="onConfirm()"
        [disabled]="isProcessing"
        [callToActionType]="'primary'"
      >
        {{ "Confirm" | translate }}
      </ws-button>
    </div>
  </div>
</div>
